import { useEffect, useState } from "react";
import api from "../lib/api";

const POLL_MS = 30_000;

export default function useUnreadCount(isPremium) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isPremium) { setCount(0); return; }
    let alive = true;
    const fetchOnce = async () => {
      try {
        const { data } = await api.get("/messages/unread-count");
        if (alive) setCount(data?.count || 0);
      } catch (err) {
        if (err?.response?.status !== 401 && process.env.NODE_ENV === "development") {
          // eslint-disable-next-line no-console
          console.error("unread-count failed:", err?.message || err);
        }
      }
    };
    fetchOnce();
    const id = setInterval(fetchOnce, POLL_MS);
    return () => { alive = false; clearInterval(id); };
  }, [isPremium]);

  return count;
}
